import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AlertController, IonModal, ToastController } from '@ionic/angular';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { NaploService } from '../naplo.service';
import { BerService } from '../../ber/ber.service';
import { DataService } from '../../data.service';
import { KeretService } from '../../keret.service';
import { SzerkZar, SzerkZarService } from '../../components/szerk-zar/szerk-zar.service';

@Component({
  selector: 'app-naplo-ugyfelek',
  templateUrl: './ugyfelek.component.html',
  styleUrls: ['../naplo-shared.scss', './ugyfelek.component.scss'],
})
export class UgyfelekComponent implements OnInit, OnDestroy {
  @ViewChild('ugyfelModal') ugyfelModal: IonModal;
  @ViewChild('importModal') importModal: IonModal;
  intezmeny = '';
  ugyfelek: any[] = [];
  szerk: any = null;
  /*  SZERKESZTÉSI ZÁR (backend/szerkesztes-zar.js) a módosításra nyitott ügyfélre (adatlap és
   *  kapcsolatok) – amíg más szerkeszti, nálunk csak olvasható. Az ablak eltűnésekor elenged. */
  zarUgyfel: SzerkZar | null = null;
  private zarKor = 0;
  /** Zár kérése; ha a válasz megérkezéséig az ablak már mást mutat (vagy bezárult), a késő zárat elengedjük. */
  private async zarKer(id: any) {
    this.zarEngedd();
    const kor = this.zarKor;
    const z = await this.szerkZar.foglal('naplo', 'naplo_ugyfel', id, { ujratolt: () => this.ugyfelUjratolt(String(id)) });
    if (kor !== this.zarKor) { z?.felenged(); return; }
    this.zarUgyfel = z;
  }
  zarEngedd() { this.zarKor++; this.zarUgyfel?.felenged(); this.zarUgyfel = null; }
  /** Más szerkeszti – nálunk nem menthető. */
  get zarTilt() { return !!this.zarUgyfel && !this.zarUgyfel.irhato; }
  /** A zár felszabadulásakor / „Újratöltés”-re: friss ügyféladat és kapcsolatok, ha az ablak még ezt mutatja. */
  private async ugyfelUjratolt(id: string) {
    await this.betolt();
    const u = this.ugyfelek.find((x: any) => String(x.id) === id);
    if (!u || String(this.szerk?.id) !== id) return;
    this.szerk = this.ugyfelAlak(u);
    await this.kapcsolatBetolt(u.id);
  }
  evek: number[] = [];

  // Szűrők: név/azonosító, adószám és adózási forma. Kliens-oldali (a teljes lista már betöltve).
  szuroNev = '';
  szuroAdoszam = '';
  szuroForma = ''; // '' = mind | kettos | egyszeres | kata | atalany

  // A szűrők bármelyikének kiürítése az egészet visszaadja.
  get szurtUgyfelek(): any[] {
    const nev = this.szuroNev.trim().toLowerCase();
    const ado = this.szuroAdoszam.replace(/\D/g, '');
    const forma = this.szuroForma;
    return (this.ugyfelek || []).filter((u) => {
      if (nev) {
        const talalat = `${u.nev || ''} ${u.nev_msz || ''} ${u.azonosito || ''}`.toLowerCase().includes(nev);
        if (!talalat) return false;
      }
      if (ado && !String(u.adoszam || '').replace(/\D/g, '').includes(ado)) return false;
      if (forma) {
        const kettos = u.konyveles_mod === 'kettos';
        if (forma === 'kettos' && !kettos) return false;
        if (forma === 'kata' && !u.kata) return false;
        if (forma === 'atalany' && !u.atalanyado) return false;
        if (forma === 'egyszeres' && (kettos || u.kata || u.atalanyado)) return false;
      }
      return true;
    });
  }

  szuroTorol() { this.szuroNev = ''; this.szuroAdoszam = ''; this.szuroForma = ''; }

  /*  NÉZET: csempék vagy lista (sok ügyfélnél a lista áttekinthetőbb). A választást a böngésző megjegyzi. */
  nezet: 'csempe' | 'lista' = (() => { try { return localStorage.getItem('naploUgyfelNezet') === 'lista' ? 'lista' : 'csempe'; } catch { return 'csempe'; } })();
  nezetValt(n: 'csempe' | 'lista') { this.nezet = n; try { localStorage.setItem('naploUgyfelNezet', n); } catch { /* privát ablak */ } }

  constructor(private naplo: NaploService, private router: Router, private toast: ToastController, private alert: AlertController, private ber: BerService,
              private data: DataService, private keret: KeretService, private http: HttpClient, private szerkZar: SzerkZarService) {}

  ngOnDestroy() { this.zarEngedd(); }

  /*  Az ügyfélválasztó mindenkié, akinek van NAPLO-joga (ügyfél nélkül semmi sem működik).
   *  Ügyfelet felvenni, módosítani, törölni viszont az Ügyfelek képernyő joga kell – a
   *  kiszolgáló is így dönt (naplo-kapu.js). A BÉR-gomb csak annak, akinek van BÉR-modulja. */
  szerkeszthet = false;
  berElerheto = false;

  /*  Gyors átváltás a kiválasztott ügyfél BÉR (bérszámfejtő) részére. Ha még nincs BÉR-ügyfél,
   *  a backend a NAPLO-ügyfélből létrehozza, beállítjuk aktívnak, és átváltunk a bérszámfejtésre.
   *
   *  ITT AZ ALRENDSZERT IS ÁT KELL ÁLLÍTANI, nem csak navigálni. A puszta `navigateByUrl('/ber/…')`
   *  megnyitotta a bér képernyőt, de a keret NAPLO módban maradt: a bal menü, a fejléc és a
   *  jogosultság-lekérés (jogkor/access/menu) továbbra is a Könyvelésé volt – a felhasználó
   *  „beragadt" a naplóba. A váltó műveletét használjuk (KeretService), célként a bér
   *  Alkalmazottak lapjával, hogy a váltás után ne a semleges kezdőlapra érkezzünk. */
  async atvaltBer(u: any) {
    try {
      const b: any = await this.ber.get('/ugyfel/by-naplo/' + u.id);
      await this.ber.init();
      await this.ber.setAktiv({ ugyfelId: b.id, ugyfelNev: b.megjelenites_nev || b.nev });
      const k = this.keret.a;
      const mod = (k?.modok() || []).find((m) => m.name === 'BER');
      if (k && mod) k.modValt(mod, '/ber/alkalmazottak');
      else this.router.navigateByUrl('/ber/alkalmazottak');   // keret nélkül (pl. fixált BÉR-app): a régi út
    } catch (e: any) {
      (await this.toast.create({ message: e?.error?.error || 'Nem sikerült átváltani a bérszámfejtésre.', duration: 2600, color: 'danger' })).present();
    }
  }

  async ngOnInit() {
    const a = await this.naplo.init();
    this.intezmeny = a.intezmeny;
    try {
      const jog = await this.data.hozzaferesek();
      this.szerkeszthet = jog.szabad('/naplo/ugyfelek');
      const modok = (await this.data.getFromStorage('sajatIntezmeny'))?.mode;
      this.berElerheto = Array.isArray(modok) && modok.includes('BER');
      this.intezmenyMode = Array.isArray(modok) ? modok.map((m: any) => String(m).toUpperCase()) : [];
    } catch { /* jog nélkül a gombok rejtve maradnak */ }
    const ev = new Date().getFullYear();
    this.evek = [ev + 1, ev, ev - 1, ev - 2, ev - 3, ev - 4];
    await this.betolt();
  }

  get aktiv() { return this.naplo.aktiv; }

  /*  PER-ÜGYFÉL MODULOK (kapcsolt mód): mely ügyfélkörös modulok vannak bekapcsolva az ügyfélnél.
   *  Pl. egy könyvelési ügyfélnek, akinek csak Könyvelés + Számfejtés kell, kikapcsolható a Gépjármű,
   *  a Készlet, a Számla és Kassza, a Tárgyi eszköz. (A backend: naplo_ugyfel_modul_tilt – opt-out.) */
  readonly MODUL_TILTHATO = ['ESZKOZ', 'SZAMLAZO', 'INVENTARIO', 'GEPJARMU'];
  intezmenyMode: string[] = [];
  modulAblak = false;
  modulUgyfel: any = null;
  modulLista: { alrendszer: string; nev: string; aktiv: boolean }[] = [];
  modulMent = false;
  /** Van-e egyáltalán olyan ügyfélkörös modul az intézményben, amit ki lehet kapcsolni? */
  get vanModulKapcsolo(): boolean { return this.szerkeszthet && this.MODUL_TILTHATO.some((m) => this.intezmenyMode.includes(m)); }

  async modulokNyit(u: any) {
    this.modulUgyfel = u; this.modulLista = []; this.modulAblak = true;
    try {
      const r: any = await this.naplo.getAbs('/api/ugyfeltorzs/ugyfel-modulok/' + u.id);
      this.modulLista = r?.modulok || [];
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült betölteni az ügyfél moduljait.'); this.modulAblak = false; }
  }
  async modulokMent() {
    if (!this.modulUgyfel) return;
    this.modulMent = true;
    try {
      const tiltott = this.modulLista.filter((m) => !m.aktiv).map((m) => m.alrendszer);
      await this.naplo.putAbs('/api/ugyfeltorzs/ugyfel-modulok/' + this.modulUgyfel.id, { tiltott });
      this.modulAblak = false;
      this.ok('A(z) ' + (this.modulUgyfel.nev || 'ügyfél') + ' moduljai mentve.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
    finally { this.modulMent = false; }
  }

  async betolt() {
    try { this.ugyfelek = await this.naplo.get('/ugyfelek/' + this.intezmeny); }
    catch { this.hiba('Nem sikerült betölteni az ügyfeleket.'); }
  }

  async valaszt(u: any) {
    await this.naplo.setAktiv({ ugyfelId: u.id, ugyfelNev: u.nev, konyveles_mod: u.konyveles_mod || 'egyszeres', tipus: u.tipus || 'ceg',
      bank_naplo: !!u.bank_naplo });
    this.ok(u.nev + ' kiválasztva.');
  }
  async evValt(ev: number) { await this.naplo.setAktiv({ ev }); this.ok('Könyvelési év: ' + ev); }

  // Ügyfél kiválasztása után a NAPLO főmenüje nyílik (onnan érhető el minden képernyő).
  belep(u: any) { this.valaszt(u).then(() => this.router.navigateByUrl('/naplo/fomenu')); }

  /** A sikertelen Ügyfélkapu-belépés részletei a kártya buboréksúgójába. */
  kauHibaCim(u: any): string {
    const h = u.ugyfelkapu_hiba;
    if (!h) return '';
    const teendo = h.kinek === 'ugyfel'
      ? 'Az ügyfél dolga: a KAÜ-fiókja nem használható (zárolt / lejárt jelszó) – ha feloldotta, a Szervíz → Ügyfélkapu-fiókokban ellenőrizd újra a belépést.'
      : 'A könyvelő dolga: a tárolt belépési adat hibás – a Szervíz → Ügyfélkapu-fiókokban írd át a jelszót vagy a TOTP-kulcsot.';
    return `Ügyfélkapu-fiók: ${h.fiok}${h.ido ? ` (${h.ido})` : ''}\n${h.uzenet}\n\nA fiók lekérései (tárhely, NAV, e-Önkormányzat…) szünetelnek, amíg nem javítják.\n${teendo}`;
  }
  kauHibaNyit() { this.router.navigateByUrl('/naplo/fiokok'); }

  uj() {
    this.zarEngedd();   // új ügyfél – nincs zár
    this.szerk = { intezmeny: this.intezmeny, azonosito: '', nev: '', konyveles_mod: 'egyszeres', tipus: 'ceg', afa_alany: true, kiegy_szamla: true, alapitvany: false, penzforgalmi_afa: false, deviza: false, kivas: false, inaktiv: false, kata: false, atalanyado: false, alanyi_mentes: false, keret: null, partner_teljes_nev: false, bank_naplo: false,
      cegforma: null, afa_gyakorisag: null, kiegeszito: false, mezog_felar: false };
    this.kapcsolat = null; this.vies = null; this.elonezetKulcs = ''; this.navUzenet = null; this.navUtolso = '';
    this.ugyfelModal.present();
  }
  szerkeszt(u: any) {
    this.kapcsolatBetolt(u.id);
    this.portalBetolt(u.id);
    this.szerk = this.ugyfelAlak(u);
    this.vies = null; this.elonezetKulcs = ''; this.navUzenet = null; this.navUtolso = '';
    this.ugyfelModal.present();
    this.zarKer(u.id);
  }
  private ugyfelAlak(u: any) {
    return { ...u, bank_naplo: !!u.bank_naplo, konyveles_mod: u.konyveles_mod || 'egyszeres', tipus: u.tipus || 'ceg', afa_alany: !!u.afa_alany, kiegy_szamla: !!u.kiegy_szamla, alapitvany: !!u.alapitvany, penzforgalmi_afa: !!u.penzforgalmi_afa, deviza: !!u.deviza, kivas: !!u.kivas, inaktiv: !!u.inaktiv, kata: !!u.kata, atalanyado: !!u.atalanyado, alanyi_mentes: !!u.alanyi_mentes, keret: u.keret != null ? Number(u.keret) : null, partner_teljes_nev: !!u.partner_teljes_nev, intezmeny: this.intezmeny,
      kiegeszito: !!u.kiegeszito, mezog_felar: !!u.mezog_felar, cegforma: u.cegforma || null, afa_gyakorisag: u.afa_gyakorisag || null };
  }

  /* ── ÜGYFÉLADAT-LAP (az RLB mintájára) ── */
  readonly cegformak = [
    { k: 'ev', n: 'Egyéni vállalkozó' }, { k: 'bt', n: 'Betéti társaság (Bt.)' }, { k: 'kft', n: 'Korlátolt felelősségű társaság (Kft.)' },
    { k: 'zrt', n: 'Zártkörű részvénytársaság (Zrt.)' }, { k: 'nyrt', n: 'Nyilvános részvénytársaság (Nyrt.)' }, { k: 'kkt', n: 'Közkereseti társaság (Kkt.)' },
    { k: 'szovetkezet', n: 'Szövetkezet' }, { k: 'egyesulet', n: 'Egyesület' }, { k: 'alapitvany', n: 'Alapítvány' }, { k: 'tarsashaz', n: 'Társasház' },
    { k: 'magan', n: 'Magánszemély (bérbeadó, adószám nélkül)' }, { k: 'magan_adoszamos', n: 'Adószámos magánszemély (bérbeadó)' },
    { k: 'egyeb', n: 'Egyéb' },
  ];
  /** Egyéni vállalkozó-e (a személyes adatai ekkor kellenek): kijelölt cégforma, vagy átalány / KATA / adóazonosító. */
  get egyeni(): boolean {
    const s = this.szerk || {};
    //  A magánszemély bérbeadó személyes adatai is kellenek: a bérlő cég 08-as M-lapjára kerülnek.
    if (s.tipus === 'ingatlan' || s.cegforma === 'magan' || s.cegforma === 'magan_adoszamos') return true;
    if (s.cegforma) return s.cegforma === 'ev';
    return !!(s.atalanyado || s.kata || /^8\d{9}$/.test(String(s.adoazonosito || '').replace(/\D/g, '')));
  }
  /*  EU-ADÓSZÁM ELLENŐRZÉS (VIES, díjmentes). Üres közösségi adószámnál a magyar adószámból képzi
   *  (HU + az első 8 jegy); érvényes találatnál, ha a mező üres volt, be is írja. */
  vies: any = null;
  viesFut = false;

  /*  ADÓZÓ ADATAI A NAV-TÓL (adószám alapján, az iroda technikai felhasználójával – naplo.js
   *  /osa/taxpayer-adozo). Az adószám mezőből kilépve a még ÜRES mezőket tölti ki; a NAV gombbal
   *  felülírja a nevet, a címet és a cégformát is. */
  navFut = false;
  navUzenet: { ok: boolean; szoveg: string } | null = null;
  private navUtolso = '';
  navTorzs(a: any): string { return String(a || '').replace(/\D/g, '').slice(0, 8); }
  async navAdozo(felulir: boolean) {
    const sz = this.szerk; if (!sz) return;
    const t = this.navTorzs(sz.adoszam);
    if (t.length !== 8 || this.navFut) return;
    if (!felulir && (t === this.navUtolso || (sz.nev && sz.irsz && sz.telepules))) return;   // automatikusan csak hiányzóra
    this.navUtolso = t; this.navFut = true; this.navUzenet = null;
    try {
      const r: any = await this.naplo.get(`/osa/taxpayer-adozo/${encodeURIComponent(this.naplo.aktiv.intezmeny || '')}?adoszam=${t}`);
      if (!r?.nev) { this.navUzenet = { ok: false, szoveg: 'A NAV nem ismeri ezt az adószámot.' }; return; }
      const tolt = (mezo: string, ertek: any) => { if (ertek != null && ertek !== '' && (felulir || !sz[mezo])) sz[mezo] = ertek; };
      tolt('nev', r.rovid_nev || r.nev);
      tolt('adoszam', r.adoszam);
      tolt('irsz', r.irsz); tolt('telepules', r.telepules); tolt('cim', r.cim);
      if (r.cegforma) tolt('cegforma', r.cegforma);
      this.navUzenet = { ok: !!r.ervenyes, szoveg: `${r.ervenyes ? '✓ NAV' : '✗ a NAV szerint nem érvényes'} · ${r.nev}` };
    } catch (e: any) { this.navUzenet = { ok: false, szoveg: e?.error?.error || 'A NAV-lekérdezés nem sikerült.' }; }
    finally { this.navFut = false; }
  }
  async viesEllenoriz() {
    const szam = String(this.szerk?.koz_adoszam || this.szerk?.adoszam || '').trim();
    if (!szam) return;
    this.viesFut = true; this.vies = null;
    try {
      this.vies = await this.naplo.get('/vies/' + encodeURIComponent(szam));
      if (this.vies?.ok && this.vies.ervenyes && !this.szerk.koz_adoszam) this.szerk.koz_adoszam = this.vies.szam;
    } catch { this.vies = { ok: false, hiba: 'A VIES szolgáltatás most nem érhető el.' }; }
    finally { this.viesFut = false; }
  }
  /** Az Online Számla (NAV technikai felhasználó) beállítása a Törzsadatokban – az ügyfél kiválasztásával. */
  async osaBeallitas() {
    const u = this.szerk;
    await this.ugyfelModal.dismiss();
    await this.valaszt(u);
    this.router.navigate(['/naplo/torzsek'], { queryParams: { nezet: 'osa' } });
  }
  /*  MUNKATERV-ELŐNÉZET: a szerkesztett adatokkal milyen bevallásokat ír elő a munkaterv. A
   *  kiszolgáló számolja (ugyanaz a szabály, mint a munkatervé), a változásra kicsit várva. */
  private elonezetKulcs = '';
  private elonezetIdozito: any = null;
  private elonezet: string[] = [];
  get munkatervElonezet(): string[] {
    const s = this.szerk || {};
    const kulcs = JSON.stringify([s.id, s.nev, s.cegforma, s.tipus, s.konyveles_mod, s.afa_alany, s.afa_gyakorisag, s.koz_adoszam, s.kata, s.atalanyado,
      s.kivas, s.alapitvany, s.kiegeszito, s.adoazonosito]);
    if (kulcs !== this.elonezetKulcs) {
      this.elonezetKulcs = kulcs;
      clearTimeout(this.elonezetIdozito);
      this.elonezetIdozito = setTimeout(async () => {
        try { this.elonezet = ((await this.naplo.post('/ugyfel/munkaterv-elonezet', this.szerk)) as any)?.nyomtatvanyok || []; }
        catch { this.elonezet = []; }
      }, 400);
    }
    return this.elonezet;
  }

  /* ── A CÉG KAPCSOLATAI: Bér, SULINFORM, Iktató ──
   *  Ugyanaz a cég több alrendszerben szerepel. A kötést eddig csak a Bér oldalán lehetett
   *  megadni – innen is lehet: a NAV-nyomtatványok, a jelenlét-átvétel és az iktatás ettől
   *  mutat ugyanarra a cégre. A könyvelés ↔ bér kötés helye változatlanul a bér-ügyfél sora. */
  kapcsolat: any = null;

  /*  ÜGYFÉLPORTÁL-HOZZÁFÉRÉS: kik láthatják a cég könyvelését, bérét (backend/ugyfelportal.js) – olvasásra. */
  portal: any[] | null = null;
  portalUj = '';
  portalHiba = '';
  async portalBetolt(id: string) {
    this.portal = null; this.portalHiba = '';
    try { this.portal = await firstValueFrom(this.http.get<any[]>(`/api/ugyfelportal/hozzaferes/${id}`)); } catch (e: any) { this.portal = []; this.portalHiba = e?.error?.error || ''; }
  }
  async portalAd() {
    this.portalHiba = '';
    try { await firstValueFrom(this.http.post(`/api/ugyfelportal/hozzaferes/${this.szerk.id}`, { felhasznalo: this.portalUj.trim() })); this.portalUj = ''; await this.portalBetolt(this.szerk.id); }
    catch (e: any) { this.portalHiba = e?.error?.error || 'Nem sikerült.'; }
  }
  async portalTorol(k: any) {
    try { await firstValueFrom(this.http.delete(`/api/ugyfelportal/hozzaferes/${this.szerk.id}/${k.id}`)); await this.portalBetolt(this.szerk.id); }
    catch (e: any) { this.portalHiba = e?.error?.error || 'Nem sikerült.'; }
  }

  /*  Az iskola (SULINFORM) bizonylatai – helyben vagy a kapcsolati kóddal összekötött másik
   *  installációról (backend/naplo-kapcsolat.js). */
  szamlaNezet: any = null;
  /*  `forras`: 'sulinform' – az iskola bizonylatai; 'szamlazo' – a cég Számla és Kassza bizonylatai
   *  (helyben, vagy a kapcsolaton át, ha a cég másik installáción számláz). */
  private elozoHonap() {
    const ma = new Date();
    const tol = new Date(ma.getFullYear(), ma.getMonth() - 1, 1), ig = new Date(ma.getFullYear(), ma.getMonth(), 0);
    const d = (x: Date) => `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, '0')}-${String(x.getDate()).padStart(2, '0')}`;
    return { tol: d(tol), ig: d(ig) };
  }
  szamlakNyit(forras: 'sulinform' | 'szamlazo' = 'sulinform') {
    this.szamlaNezet = { forras, ugyfelId: this.szerk?.id, ...this.elozoHonap(), lista: null, fut: false, hiba: '' };
    this.szamlakBetolt();
  }
  async szamlakBetolt() {
    const n = this.szamlaNezet; if (!n) return;
    n.fut = true; n.hiba = '';
    try {
      const ut = n.forras === 'szamlazo' ? 'szamlazo/bizonylatok' : 'szamlak';
      const r: any = await firstValueFrom(this.http.get(`/api/naplo-kapcsolat/${n.ugyfelId}/${ut}`, { params: { tol: n.tol, ig: n.ig } }));
      n.lista = r.szamlak || []; n.forras = r.forras; n.figyelmeztetes = r.figyelmeztetes || [];
    } catch (e: any) { n.lista = null; n.hiba = e?.error?.error || 'A számlák nem kérhetők le.'; }
    n.fut = false;
  }
  szamlaOsszeg(l: any[]) { return (l || []).reduce((a, s) => a + (Number(s.osszeg) || 0), 0); }
  szamlaPdf(s: any) {
    const n = this.szamlaNezet;
    const ut = n.forras === 'szamlazo' ? `szamlazo/pdf/${s.id}` : `szamla/${s.id}/pdf`;
    this.data.megnyitFajl(`/api/naplo-kapcsolat/${n.ugyfelId}/${ut}`, `${s.tipus_nev} ${s.szamlaszam}`);
  }

  /*  A cég készlete (Készletkezelés) – helyben vagy a kapcsolaton át; olvasás. */
  keszletNezet: any = null;
  async keszletNyit() {
    this.keszletNezet = { ugyfelId: this.szerk?.id, ful: 'keszlet', ...this.elozoHonap(), cikkek: null, mozgasok: null, fut: false, hiba: '', kereso: '' };
    await this.keszletBetolt();
  }
  async keszletBetolt() {
    const n = this.keszletNezet; if (!n) return;
    n.fut = true; n.hiba = '';
    try {
      if (n.ful === 'keszlet') {
        const r: any = await firstValueFrom(this.http.get(`/api/naplo-kapcsolat/${n.ugyfelId}/keszlet`));
        n.cikkek = r.cikkek || []; n.ertek = r.ertek; n.forras = r.forras; n.figyelmeztetes = r.figyelmeztetes || [];
      } else {
        const r: any = await firstValueFrom(this.http.get(`/api/naplo-kapcsolat/${n.ugyfelId}/keszlet/mozgasok`, { params: { tol: n.tol, ig: n.ig } }));
        n.mozgasok = r.mozgasok || []; n.forras = r.forras; n.figyelmeztetes = r.figyelmeztetes || [];
      }
    } catch (e: any) { n.hiba = e?.error?.error || 'A készlet nem kérhető le.'; }
    n.fut = false;
  }
  keszletSzurt(n: any) {
    const k = String(n.kereso || '').trim().toLowerCase();
    return (n.cikkek || []).filter((c: any) => !k || `${c.nev} ${c.cikkszam || ''} ${c.csoport || ''}`.toLowerCase().includes(k));
  }
  mozgasTipus(t: string) { return ({ bevet: 'Bevét', kiad: 'Kiadás', atvezet: 'Átvezetés', selejt: 'Selejt', leltar: 'Leltár', nyito: 'Nyitó' } as any)[t] || t; }
  kapcsolatMent = false;
  /** A betöltéskori állapot: a fő Mentés ebből látja, hogy a Kapcsolatok blokk is változott-e. */
  private kapcsolatEredeti = '';
  async kapcsolatBetolt(id: string) {
    this.kapcsolat = null;
    this.kapcsolatEredeti = '';
    try {
      const r: any = await this.naplo.get(`/ugyfel/${id}/kapcsolatok`);
      this.kapcsolat = { ...r, valasztott: { ber_ugyfel_id: r.ber?.id || '', sulinform_feladatellatas: r.ugyfel?.sulinform_feladatellatas || '', tandij_bank_id: r.ugyfel?.tandij_bank_id || '',
        iktato_intezmeny: r.ugyfel?.iktato_intezmeny || '', iktato_konyv: r.ugyfel?.iktato_konyv || '' } };
      this.kapcsolatEredeti = JSON.stringify(this.kapcsolat.valasztott);
    } catch { this.kapcsolat = null; }
  }
  get iktatoKonyvek() {
    const i = this.kapcsolat?.valasztott?.iktato_intezmeny;
    return (this.kapcsolat?.konyvek || []).filter((k: any) => !i || k.intezmeny === i);
  }
  async kapcsolatMentes() {
    if (!this.szerk?.id || !this.kapcsolat || this.zarTilt) return;
    this.kapcsolatMent = true;
    try {
      await this.naplo.put(`/ugyfel/${this.szerk.id}/kapcsolatok`, this.kapcsolat.valasztott);
      await this.kapcsolatBetolt(this.szerk.id);
      this.ok('A cég kapcsolatai mentve.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni a kapcsolatokat.'); }
    finally { this.kapcsolatMent = false; }
  }

  /* ── Cég átvétele a BÉR-ből (a bérszámfejtésben már rögzített foglalkoztatóból) ── */
  berUgyfelek: any[] = [];
  importValasztott: Record<string, boolean> = {};
  async importNyit() {
    this.importValasztott = {};
    try { this.berUgyfelek = await this.naplo.get('/ber-ugyfelek/' + this.intezmeny); }
    catch { this.berUgyfelek = []; }
    this.importModal.present();
  }
  async importMent() {
    const idk = Object.keys(this.importValasztott).filter((k) => this.importValasztott[k]);
    if (!idk.length) return this.hiba('Nincs kijelölt cég.');
    try {
      const r: any = await this.naplo.post('/ugyfel/import-ber', { intezmeny: this.intezmeny, ber_ugyfel_idk: idk });
      await this.importModal.dismiss();
      await this.betolt();
      this.ok(`${r?.letrehozott || 0} cég átvéve, ${r?.osszekotott || 0} összekötve.`
        + (r?.arva ? ` (${r.arva} cégnél a régi, törölt ügyfélre mutató kötés helyett új készült.)` : ''));
    } catch (e: any) { this.hiba(e?.error?.error || 'Az átvétel nem sikerült.'); }
  }

  async mentes() {
    if (this.zarTilt) return;
    if (!this.szerk?.nev?.trim()) return this.hiba('A név kötelező.');
    if (!this.szerk?.azonosito?.trim()) return this.hiba('Az azonosító kötelező.');
    this.szerk.intezmeny = this.intezmeny;
    try {
      let ujId = this.szerk.id;
      if (this.szerk.id) {
        await this.naplo.put('/ugyfel/' + this.szerk.id, this.szerk);
        /*  A Kapcsolatok blokknak saját gombja is van, de a fő Mentés azt is elmenti, ha
         *  változott – különben a kiválasztott SULINFORM-intézmény / tandíj-számla csendben
         *  elveszett, ha valaki csak a fő gombot nyomta meg (Zenit, 2026-10-05). */
        if (this.kapcsolat && JSON.stringify(this.kapcsolat.valasztott) !== this.kapcsolatEredeti) {
          await this.naplo.put(`/ugyfel/${this.szerk.id}/kapcsolatok`, this.kapcsolat.valasztott);
        }
      } else {
        //  ÚJ ügyfél. (Korábban ez az ág a Kapcsolatok-feltételhez tapadt, így MÓDOSÍTÁSKOR is
        //  lefutott: a mentés után még egy létrehozás ment ki, „Ezzel az azonosítóval már létezik
        //  ügyfél” hibával, és az ablak nyitva maradt – user, 2026-10-08.)
        const r: any = await this.naplo.post('/ugyfel', this.szerk); ujId = r?.id;
      }
      // Új ügyfélnél töltsük fel az alap rovat- és pénztártörzset.
      if (ujId && !this.szerk.id) await this.naplo.post('/ugyfel/' + ujId + '/alapertelmezesek', {});
      await this.ugyfelModal.dismiss();
      await this.betolt();
      /*  A KIVÁLASZTOTT ÜGYFÉL frissül: a menü (Bank, kettős/egyszeres pontok) az aktív ügyfél
       *  tárolt adataiból dolgozik, ezért a „Bank használata” vagy a könyvelési mód átállítása
       *  eddig csak az ügyfél újraválasztása után hatott (2026-11-02). */
      const friss = this.ugyfelek?.find((u: any) => u.id === ujId);
      if (friss && friss.id === this.naplo.aktiv.ugyfelId) {
        await this.naplo.setAktiv({ ugyfelNev: friss.nev, konyveles_mod: friss.konyveles_mod || 'egyszeres', tipus: friss.tipus || 'ceg',
          bank_naplo: !!friss.bank_naplo });
      }
      this.ok('Mentve.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }

  async torol(u: any) {
    const a = await this.alert.create({
      header: 'Törlés', message: `Biztosan törli: ${u.nev}?`,
      buttons: [{ text: 'Mégse', role: 'cancel' }, {
        text: 'Törlés', role: 'destructive', handler: async () => {
          try { await this.naplo.del('/ugyfel/' + u.id); await this.betolt(); this.ok('Törölve.'); }
          catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült törölni.'); }
        }
      }],
    });
    a.present();
  }

  private async ok(m: string) { (await this.toast.create({ message: m, duration: 1600, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 2600, color: 'danger' })).present(); }
}
